import React from 'react';
import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';
import Tooltip from '../ui/Tooltip';
import { usePreferencesStore } from '../../store/preferencesStore';
import { resolveShortcutKeys, shortcutLabelString } from '../../config/shortcuts';
import { togglePalette } from './paletteOpenState';
import './palette.css';

/**
 * The title-bar "Search ⌘K" button (PLAN §2.1, Linear / Slack / Notion):
 * opens the palette with the mouse. `mousedown` is swallowed so focus stays
 * where it was and the palette gives it back on close.
 */
export default function PaletteSearchButton() {
  const { t } = useTranslation();
  const keyboardShortcuts = usePreferencesStore((s) => s.keyboardShortcuts);
  const label = shortcutLabelString(resolveShortcutKeys('commandPalette', keyboardShortcuts));
  return (
    <Tooltip content={t('palette.titlebar.tooltip', { shortcut: label })} side="bottom">
      <button
        type="button"
        className="palette-titlebar-button"
        data-testid="palette-titlebar-button"
        style={{ WebkitAppRegion: 'no-drag' }}
        onMouseDown={(e) => e.preventDefault()}
        onClick={(e) => togglePalette({ at: e.timeStamp })}
      >
        <Search size={13} aria-hidden="true" />
        <span>{t('palette.titlebar.search')}</span>
        {label ? <kbd className="palette-kbd">{label}</kbd> : null}
      </button>
    </Tooltip>
  );
}
